/**
 * The counter email's "Respond" link: opens the property page at the investor's offer card.
 *
 * A path rather than a query string, since magic-link redirects only carry paths.
 */

import { redirect } from '@tanstack/react-router'

export const Route = createFileRoute({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/properties/$id', params: { id: params.id }, search: { focus: 'offer' } })
  },
})
